// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/upload-document-file-request-schema',
  type: 'object',
  required: ['uploadFile'],
  properties: {
    uploadFile: {
      type: 'object',
    },
  },
} as IJSONSchema;

export default schema;
